// Trading Mind Layer — Constants & defaults

export const DEFAULT_MIND_SETTINGS = {
  // Risk limits
  maxRiskPercent: 2,
  maxTradesPerDay: 10,
  minTimeBetweenTrades: 120, // seconds
  dailyLossLimit: 5000,

  // Cooldown
  cooldownMinutes: 30,
  consecutiveLossThreshold: 2,

  // Energy
  energyThreshold: 30,

  // Phase 2
  pnlBreakThreshold: 10000,
  highExposureMultiplier: 3,
  normalPositionSize: 50000,

  // Feature toggles
  enablePreTradeCheck: true,
  enableCooldown: true,
  enableRiskGuard: true,
  enableOvertradingGuard: true,
  enableRevengeGuard: true,
  enableEnergyGuard: true,
  enableDailyLossGuard: true,
};

export const SCORE_THRESHOLDS = {
  readiness: {
    excellent: { min: 80, color: 'green', label: 'Excellent' },
    good:      { min: 60, color: 'blue',  label: 'Good' },
    caution:   { min: 40, color: 'yellow', label: 'Caution' },
    poor:      { min: 0,  color: 'red',   label: 'Poor' },
  },
  energy: {
    high:    { min: 70, color: 'green',  label: 'High' },
    medium:  { min: 40, color: 'yellow', label: 'Medium' },
    low:     { min: 0,  color: 'red',    label: 'Low' },
  },
};

export const INTENTION_OPTIONS = [
  'Scalping — quick in-and-out',
  'Swing — position for days',
  'Learning — paper/small size',
  'Income — steady premium selling',
  'Recovery — careful, protect capital',
  'YOLO — high conviction bet',
];

export const GUARD_META = {
  PRE_TRADE_CHECK: {
    id: 'PRE_TRADE_CHECK',
    label: 'Pre-trade check missing',
    severity: 'prompt',
    overridable: true,
    description: 'Complete your daily readiness check before trading.',
  },
  LOSS_STREAK: {
    id: 'LOSS_STREAK',
    label: 'Loss streak cooldown',
    severity: 'warn',
    overridable: true,
    description: 'You have hit consecutive losses. Take a breather.',
  },
  OVERTRADE_COUNT: {
    id: 'OVERTRADE_COUNT',
    label: 'Trade count limit',
    severity: 'warn', // becomes 'block' at 100%
    overridable: true, // becomes false at 100%
    description: 'Approaching your daily trade limit.',
  },
  OVERTRADE_SPEED: {
    id: 'OVERTRADE_SPEED',
    label: 'Trading too fast',
    severity: 'warn',
    overridable: true,
    description: 'Slow down — trading too frequently.',
  },
  REVENGE_TRADE: {
    id: 'REVENGE_TRADE',
    label: 'Revenge trade detected',
    severity: 'warn',
    overridable: true,
    description: 'Same instrument shortly after a loss — could be revenge trading.',
  },
  RISK_PER_TRADE: {
    id: 'RISK_PER_TRADE',
    label: 'Risk limit exceeded',
    severity: 'block',
    overridable: false,
    description: 'Order exceeds your maximum risk per trade. Reduce size.',
  },
  DAILY_LOSS: {
    id: 'DAILY_LOSS',
    label: 'Daily loss limit',
    severity: 'warn', // becomes 'block' at 100%
    overridable: true, // becomes false at 100%
    description: 'Approaching daily loss limit.',
  },
  LOW_ENERGY: {
    id: 'LOW_ENERGY',
    label: 'Low energy score',
    severity: 'warn',
    overridable: true,
    description: 'Your energy score is low. Consider taking a break.',
  },
};

export const READINESS_WEIGHTS = {
  mood: 0.20,
  focus: 0.35,
  stress: 0.25,
  sleep: 0.20,
};
